import { useNavigate } from 'react-router-dom';

import { Typography } from '../../../designComponents';
import { FooterSectionStyled } from '../style';

type Menu = {
  label: string;
  url: string;
}[];

const generalMenu: Menu = [
  {
    label: 'Home',
    url: '/',
  },
  {
    label: 'About Us',
    url: '/about',
  },
  {
    label: 'Services',
    url: '/services',
  },
  {
    label: 'Pricing',
    url: '/pricing',
  },
];

const General = () => {
  const navigate = useNavigate();
  return (
    <FooterSectionStyled>
      <Typography fontColor="white" className="title">
        GENERAL
      </Typography>
      {generalMenu?.map((menu, index) => {
        return (
          <div className="menu" key={index} onClick={() => navigate(menu.url)}>
            <Typography
              fontColor="white"
              style={{ cursor: 'pointer' }}
              className="menu-item"
            >
              {menu?.label}
            </Typography>
          </div>
        );
      })}
    </FooterSectionStyled>
  );
};

export default General;
